// Public keys that check the signature in the reference admit card's QR link
// (/roll-number/<rollno>?k=<version>&s=<signature>), keyed by version.
//
// ECDSA P-256, base64 SPKI DER. These only VERIFY — the matching private key
// is QR_SIGN_PRIVATE_KEY in the backend .env and never leaves the server.
// To rotate: add the new version here (keep the old one so cards already
// printed still check out), then set QR_SIGN_PRIVATE_KEY / QR_SIGN_KEY_VERSION
// in the backend.
export const ROLL_NO_QR_PUBLIC_KEYS = {
  1: "MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEpT8FVCO3ZaMZnD37P0/R1naMm4YxJBcDShtSYLIS+juHRR3lPdJO/Sz7TKMzTW8gItrkxlXQqTr/9HOqLZRJ2g==",
};

// Must match the backend (services/qrService.js → signRollNo):
//   message = "MHTCET-ROLLNO|<key version>|<roll number>"
export const ROLL_NO_SIGN_CONTEXT = "MHTCET-ROLLNO";

// Same roll-number shape the Data Verifier accepts.
export const ROLL_NO_PATTERN = /^[A-Za-z0-9-]{1,30}$/;

// Reads { rollno, k, s } from the link path of either form the backend prints:
//   /r/<rollno>.<key version>.<signature>        (current, shorter → simpler QR)
//   /roll-number/<rollno>?k=<version>&s=<sig>    (first form, still accepted)
// Returns null for any other path. Nothing here checks the signature.
export const readRollNoLink = (pathname, searchParams) => {
  try {
    const short = pathname.match(/\/r\/([^/]+)\/?$/);
    if (short) {
      const parts = decodeURIComponent(short[1]).split(".");
      if (parts.length !== 3) return null;
      const [rollno, k, s] = parts;
      return { rollno, k, s };
    }
    const long = pathname.match(/\/roll-number\/([^/]+)\/?$/);
    if (long) {
      return {
        rollno: decodeURIComponent(long[1]),
        k: searchParams.get("k") || "",
        s: searchParams.get("s") || "",
      };
    }
  } catch (e) {
    // Malformed %-escape in the path.
  }
  return null;
};
